<template>
  <div class="icp-page d-flex-center">
    <div class="text">© 2023-2024 All Rights Reserved</div>
    <div class="link">@粤ICP备xxxxxxxxxxxxxx号-23</div>
  </div>
</template>
  
  <script>
export default {
  name: "ICP",

  data() {
    return {};
  },
};
</script>
  
<style lang="scss" scoped>
.icp-page {
  background-color: #fff;
  height: 30px;
  border-top: 1px solid #E5E6EB;

  .text,
  .link {
    font-size: 10px;
    color: #86909c;
    line-height: 18px;
    height: 18px;
  }
}
</style>
  
  